export const auth0Config = {
  domain: 'smartscribehealth.us.auth0.com',
  clientId: 'RG4FwiozZWwAAe83xQxv2metpgJaPe0j',
  audience: 'https://api.smartscribe.health',
};

export const getAuth0RedirectUri = () =>
  window.location.origin +
  (typeof import.meta.env.VITE_SHARED_AUTH_CALLBACK === 'string' &&
  import.meta.env.VITE_SHARED_AUTH_CALLBACK
    ? import.meta.env.VITE_SHARED_AUTH_CALLBACK
    : '/callback');
